<template>
  <div class="homework-answer-manage">
    <h2>学生答案管理</h2>

    <div class="filter-section">
      <el-select 
        v-model="selectedHomeworkId" 
        placeholder="请选择作业" 
        clearable
        filterable
        style="width: 300px; margin-right: 10px"
        @change="handleHomeworkChange"
      >
        <el-option
          v-for="homework in homeworkList"
          :key="homework.id"
          :label="homework.homeworkTitle"
          :value="homework.id"
        />
      </el-select>
      <el-button type="primary" @click="search">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="answerList" style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="题目图片" width="120">
        <template slot-scope="scope">
          <el-image 
            v-if="scope.row.homeworkImage" 
            :src="scope.row.homeworkImage" 
            style="width: 80px; height: 60px" 
            fit="cover"
            :preview-src-list="[scope.row.homeworkImage]"
          />
          <span v-else style="color: #999">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="homeworkTitle" label="作业题目" width="200" />
      <el-table-column prop="answerContent" label="学生答案" width="250" show-overflow-tooltip />
      <el-table-column label="答案图片" width="120">
        <template slot-scope="scope">
          <el-image 
            v-if="scope.row.attachmentUrl" 
            :src="scope.row.attachmentUrl" 
            style="width: 80px; height: 60px" 
            fit="cover"
            :preview-src-list="[scope.row.attachmentUrl]"
          />
          <span v-else style="color: #999">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="studentName" label="姓名" width="120" />
      <!-- <el-table-column v-if="hasPhoneNumber" prop="studentPhone" label="电话" width="150" /> -->
      <el-table-column label="提交时间" width="180">
        <template slot-scope="scope">
          {{formatTime(scope.row.submitTime)}}
        </template>
      </el-table-column>
      <el-table-column prop="score" label="评分" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.score !== null && scope.row.score !== undefined">{{scope.row.score}}分</span>
          <span v-else style="color: #999">未评分</span>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="评语" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.comment">{{scope.row.comment}}</span>
          <span v-else style="color: #999">暂无评语</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="openScoreDialog(scope.row)">
            {{scope.row.score !== null && scope.row.score !== undefined ? '修改评分' : '评分'}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="loadAnswerList"
      style="margin-top: 20px; text-align: center"
    />

    <!-- 评分对话框 -->
    <el-dialog 
      :title="scoreDialogTitle" 
      :visible.sync="scoreDialogVisible" 
      width="500px"
      @close="closeScoreDialog"
    >
      <el-form :model="scoreForm" label-width="80px">
        <el-form-item label="学生姓名">
          <span>{{scoreForm.studentName}}</span>
        </el-form-item>
        <el-form-item label="作业题目">
          <span>{{scoreForm.homeworkTitle}}</span>
        </el-form-item>
        <el-form-item label="学生答案">
          <div style="max-height: 150px; overflow-y: auto; padding: 10px; background: #f5f5f5; border-radius: 4px;">
            {{scoreForm.answerContent}}
          </div>
        </el-form-item>
        <el-form-item v-if="scoreForm.attachmentUrl" label="答案图片">
          <el-image 
            :src="scoreForm.attachmentUrl" 
            style="width: 200px; height: auto" 
            fit="contain"
            :preview-src-list="[scoreForm.attachmentUrl]"
          />
        </el-form-item>
        <el-form-item label="评分" required>
          <el-input-number 
            v-model="scoreForm.score" 
            :min="0" 
            :max="100" 
            placeholder="请输入分数(0-100)"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="评语">
          <el-input 
            v-model="scoreForm.comment" 
            type="textarea" 
            :rows="4"
            placeholder="请输入评语"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeScoreDialog">取消</el-button>
        <el-button type="primary" @click="submitScore">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import homeworkApi from '@/api/homework'

export default {
  name: 'HomeworkAnswerManage',
  data() {
    return {
      answerList: [],
      homeworkList: [],
      selectedHomeworkId: null,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      scoreDialogVisible: false,
      scoreForm: {
        id: null,
        studentName: '',
        homeworkTitle: '',
        answerContent: '',
        attachmentUrl: '',
        score: null,
        comment: ''
      }
    }
  },
  computed: {
    scoreDialogTitle() {
      return this.scoreForm.score !== null && this.scoreForm.score !== undefined ? '修改评分' : '评分'
    }
    // 检查是否有学生有手机号
    // hasPhoneNumber() {
    //   return this.answerList.some(answer => answer.studentPhone)
    // }
  },
  mounted() {
    this.loadHomeworkList()
    this.loadAnswerList()
  },
  methods: {
    async loadHomeworkList() {
      try {
        const res = await homeworkApi.getHomeworkList(1, 1000, null, null)
        this.homeworkList = res.data.data
      } catch (error) {
        this.$message.error('加载作业列表失败')
      }
    },
    async loadAnswerList() {
      try {
        const res = await homeworkApi.getAnswerList(
          this.currentPage, 
          this.pageSize, 
          this.selectedHomeworkId, 
          null
        )
        this.answerList = res.data.data
        this.total = res.data.total
      } catch (error) {
        this.$message.error('加载答案列表失败')
      }
    },
    handleHomeworkChange() {
      this.currentPage = 1
      this.loadAnswerList()
    },
    search() {
      this.currentPage = 1
      this.loadAnswerList()
    },
    reset() {
      this.selectedHomeworkId = null
      this.currentPage = 1
      this.loadAnswerList()
    },
    openScoreDialog(row) {
      this.scoreForm = {
        id: row.id,
        studentName: row.studentName,
        homeworkTitle: row.homeworkTitle,
        answerContent: row.answerContent,
        attachmentUrl: row.attachmentUrl,
        score: row.score,
        comment: row.comment || ''
      }
      this.scoreDialogVisible = true
    },
    closeScoreDialog() {
      this.scoreDialogVisible = false
      this.scoreForm = {
        id: null,
        studentName: '',
        homeworkTitle: '',
        answerContent: '',
        attachmentUrl: '',
        score: null,
        comment: ''
      }
    },
    async submitScore() {
      if (this.scoreForm.score === null || this.scoreForm.score === undefined) {
        this.$message.warning('请输入评分')
        return
      }
      
      try {
        const res = await homeworkApi.scoreAnswer({
          id: this.scoreForm.id,
          score: this.scoreForm.score,
          comment: this.scoreForm.comment
        })
        
        if (res.data.code === 200) {
          this.$message.success('评分成功')
          this.closeScoreDialog()
          this.loadAnswerList()
        } else {
          this.$message.error(res.data.message || '评分失败')
        }
      } catch (error) {
        this.$message.error('评分失败')
      }
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      
      // 如果是字符串，尝试解析
      const date = new Date(time)
      
      // 检查日期是否有效
      if (isNaN(date.getTime())) return time
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.homework-answer-manage {
  padding: 20px;
}

.filter-section {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
</style>
